import { render, staticRenderFns } from "./RewardsManager.vue?vue&type=template&id=15113798&scoped=true"
import script from "./RewardsManager.vue?vue&type=script&lang=js"
export * from "./RewardsManager.vue?vue&type=script&lang=js"
import style0 from "./RewardsManager.vue?vue&type=style&index=0&id=15113798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15113798",
  null
  
)

export default component.exports